import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import { PlainInfoData } from '../../../types/dashboard';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import parse from 'html-react-parser';
import {
  CLASS_DAILY_AVG_BOOKS_LEARNED,
  CLASS_MAX_CONCENTRATION_TIME_DETAILS,
  CLASS_NOTE_USAGE_TIME_DETAILS,
  CLASS_TOTAL_LEARNING_TIME_DETAILS,
  FROM_DATE_TO_DATE,
  MIN_MAX_BOOKS_LEARNED_DETAILS,
  TOTAL_TIME_OF_LEARNING,
} from '../../../constants/common';

interface PlainInfoPanelProps {
  cardId: string;
  title: string;
  data: PlainInfoData;
  isOpen: boolean;
  onClose: () => void;
}

export default function PlainInfoPanel({
  cardId,
  title,
  data,
  isOpen,
  onClose,
}: PlainInfoPanelProps) {
  const cx = classNames.bind(styles);

  const renderAdditionalInfo = () => {
    switch (cardId) {
      case 'total-time':
        if (data.startDate && data.endDate) {
          return (
            <p>
              {FROM_DATE_TO_DATE.replace('{startDate}', data.startDate).replace(
                '{endDate}',
                data.endDate
              )}
            </p>
          );
        } else if (data.studentCount !== undefined) {
          return parse(
            `<p>
            ${CLASS_TOTAL_LEARNING_TIME_DETAILS.replace(
              '{N}',
              data.studentCount.toString()
            )}
            </p>`
          );
        }
        break;
      case 'book':
        return (
          <p>
            {data.studentCount === undefined
              ? MIN_MAX_BOOKS_LEARNED_DETAILS.replace(
                  '{min}',
                  (data.min ?? 0).toString()
                ).replace('{max}', (data.max ?? 0).toString())
              : CLASS_DAILY_AVG_BOOKS_LEARNED.replace(
                  '{N}',
                  data.studentCount.toString()
                )}
          </p>
        );
      case 'focus':
        return (
          <p>
            {data.studentCount === undefined
              ? TOTAL_TIME_OF_LEARNING.replace(
                  '{total}',
                  (data.total ?? 0).toString()
                )
              : CLASS_MAX_CONCENTRATION_TIME_DETAILS.replace(
                  '{N}',
                  data.studentCount.toString()
                )}
          </p>
        );
      case 'note':
        return (
          <p>
            {data.studentCount === undefined
              ? TOTAL_TIME_OF_LEARNING.replace(
                  '{total}',
                  (data.total ?? 0).toString()
                )
              : CLASS_NOTE_USAGE_TIME_DETAILS.replace(
                  '{N}',
                  data.studentCount.toString()
                )}
          </p>
        );
      default:
        break;
    }
    return null;
  };

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader cardId={cardId} title={title} onClose={onClose} />
      <div className={cx('widget_content', 'plain', cardId)}>
        <div className={cx('info')}>
          {renderAdditionalInfo()}
          <div className={cx('info_desc')}>{parse(data.description)}</div>
        </div>
        {data.subtext && <p className={cx('subtext')}>{parse(data.subtext)}</p>}
      </div>
    </PanelContainer>
  );
}
